import React from 'react';
import {connect} from 'react-redux';

import classNames from 'classnames';
import {CardDisplay} from './CardDisplay';
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import {FormGroup, Input, Label} from "reactstrap";
import { FormattedMessage, useIntl } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const Card: React.FC<CardProps> = ({
                                     display,
                                     selectable,
                                     dropable,
                                     selected,
                                     my,
                                     text,
                                     table,
                                     army,
                                     setName,
                                     select,
                                     unselect
                                   }) => {
  switch (display) {
    case CardDisplay.DEFAULT:
      return (<div className="col-12 col-md-2">
        <div className="card ms-md-1 me-md-1 mt-1">
          <i className="fas fa-3x fa-question mt-md-5 mb-md-5 me-md-4 ms-md-4"></i>
        </div>
      </div>);
    case CardDisplay.TEXT:
      return (
        <div className="col-12 col-md-3" onClick={() => select()}>
          <div className={classNames('card ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2 pt-md-4 pb-md-5', {
            'selectable': selectable,
            'selected': selected
          })}><p className="big mt-md-5 mb-md-4">{text}</p></div>
        </div>);
    case CardDisplay.ARMY:
      return (
        <div className="col-12 col-md-2  mb-1 mb-md-2" onClick={() => select()}>
          <div className={classNames('army ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2 pt-md-4 pb-md-3', {
            'selectable': selectable,
            'selected': selected
          })}>
            <img className="float-start float-md-none ms-2 ms-md-0" alt={army.name} src={army.logo}/>
            <p>{army.name}</p>
          </div>
        </div>);
    case CardDisplay.ARMY_EDIT:
      return (
        <div className="col-12 col-md-2  mb-1 mb-md-2">
          <div onClick={() => select()}
               className={classNames('army ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2 pt-md-4 pb-md-3', {
                 'selectable': selectable,
                 'selected': selected
               })}>
            <img className="float-start float-md-none ms-2 ms-md-0" alt={army.name} src={army.logo}/>
            <p>{army.name}</p>
          </div>
          <FormGroup row={false} onClick={() => {
          }}>
            <Label><FormattedMessage {...defaultMessages.toolPairingPlayerName} /></Label>
            <Input
              type={'text'}
              placeholder={useIntl().formatMessage(defaultMessages.toolPairingPlayerPlaceholder)}
              onChange={(e) => setName(e.target.value)}
            />
          </FormGroup>
        </div>);
    case CardDisplay.TEAM_ARMY:
      return (
        <div className="col-12 col-md-2 mb-1 mb-md-2 text-center" onClick={() => select()}>
          <div className={classNames('army ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2 pt-md-4 pb-md-3', {
            'my': my,
            'opponent': !my,
            'selectable': selectable,
            'selected': selected
          })}>
            <img className="float-start float-md-none ms-2 ms-md-0" alt={army.name} src={army.logo}/>
            <p>{army.name}</p>
          </div>
          {army.playerName != null && army.playerName}
        </div>);
    case CardDisplay.DRAW_DEFAULT:
      return (<div className="col-12 col-md-3 p-0 m-0">
        <div className="card ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2">
          <i className="fas fa-3x fa-question mt-md-5 mb-md-5 me-md-4 ms-md-4"></i>
        </div>
      </div>);
    case CardDisplay.DRAW:
      return (<div className="col-12 col-md-3 p-0 m-0">
        <div className={classNames('army ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2', {
          'my': my,
          'opponent': !my,
          'selectable': selectable,
          'selected': selected
        })}>
          <img className="float-start float-md-none ms-2 ms-md-0" alt={army.name} src={army.logo}/>
          <p className="mt-1 mb-1">{army.name}</p>
          <div className="clearboth"></div>
        </div>
      </div>);
    case CardDisplay.DRAW_RESPONSE:
      return (<div className="col-5 col-md-3 p-0 m-0" onClick={() => select()}>
        <i className={classNames('fa fa-2x fa-trash-alt float-end mt-2 me-2', {'hidden': !dropable})}
           onClick={() => unselect()}></i>
        <div className={classNames('army ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2', {
          'my': my,
          'opponent': !my,
          'selectable': selectable,
          'selected': selected
        })}>
          <img className="ms-2 ms-md-0" alt={army.name} src={army.logo}/>
          <p className="mt-1 mb-1">{army.name}</p>
          <div className="clearboth"></div>
        </div>
      </div>);
    case CardDisplay.MATCH:
      return (<div className="col-5 col-md-5 p-0 m-0 text-center">
        <div className={classNames('army ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2', {
          'my': my,
          'opponent': !my,
          'selectable': selectable,
          'selected': selected
        })}>
          <img className="ms-2 ms-md-0" alt={army.name} src={army.logo}/>
          <p>{army.name}</p>
        </div>
        {army.playerName != null && army.playerName}
      </div>);
    case CardDisplay.TABLE:
      return (
        <div className="col-12 col-md-2  mb-1 mb-md-2" onClick={() => select()}>
          <div className={classNames('table ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2 pt-md-4 pb-md-3', {
            'selectable': selectable,
            'selected': selected
          })}>
            <h2 className="ms-2 ms-md-0">{table.initials}</h2>
            <p>{table.name}</p>
          </div>
        </div>);
    default: // CardDisplay.HIDDEN:
      return (<div className="col-4 col-md-2">
        <div className="card ms-md-1 me-md-1 mt-1 mb-1 pt-2 pb-2 pt-md-3 pb-md-4">
          <i className="fas fa-3x fa-chess-rook mt-md-3 mb-md-3 me-md-2 ms-md-2"></i>
        </div>
      </div>);
  }
};

const mapStateToProps = (state: AppState, owsProps: any) => {

  return {
    display: owsProps.display,
    selectable: owsProps.selectable || false,
    dropable: owsProps.dropable || false,
    selected: owsProps.selected == true,
    setName: owsProps.setName,
    my: owsProps.my == true,
    text: owsProps.text,
    army: owsProps.army,
    table: owsProps.table,
  }
};

const mapDispatchToProps = (dispatch: Dispatch, owsProps: any) => {
  return {
    select: () => {
      if (owsProps.selectable) {
        owsProps.select()
      }
    },
    unselect: () => {
      if (owsProps.army) {
        owsProps.unSelect()
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Card);

type CardProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
